import { render, staticRenderFns } from "./move-assignments-target.vue?vue&type=template&id=6e81cf76"
import script from "./move-assignments-target.vue?vue&type=script&lang=js"
export * from "./move-assignments-target.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports